import React, { FC } from 'react'
import { Card } from 'src/modules/components/lib/card'
import { Footer } from 'src/modules/components/lib/footer'
import { Logo } from 'src/modules/components/lib/logo'
import { InlineText, Text } from 'src/modules/components/lib/text'
import { Flexbox, View } from 'src/modules/components/lib/view'
import { AppState } from 'src/modules/entities/app-state/entity'
import { Button } from '../../components/lib/button'
import { Refresh } from '../../components/lib/curon-icon'

type Props = { appState?: AppState }

export const MaintenanceScreen: FC<Props> = ({ appState }) => {
  const content = (appState?.message || '')
    .split(/\n/g)
    .map((text: string, index: number) => (
      <Text key={`body-content-${index}`}>{text || <br />}</Text>
    ))

  return (
    <Flexbox
      flexDirection="column"
      backgroundColor="whiteGray"
      minHeight="100vh"
    >
      <Flexbox
        p={3}
        flexGrow={1}
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <View maxWidth="640px">
          <Card padding="65px 15px">
            <View textAlign="center">
              <Logo />
            </View>
            <Text textAlign="center" mt="35px" lineHeight="30px">
              現在メンテナンス中です。
              <br />
              しばらく時間をおいてから、再度アクセスしてください。
            </Text>
            <Text textAlign="center" mt="15px">
              {content}
            </Text>
          </Card>

          <Flexbox
            mt={4}
            bg={'#E7F4FD'}
            p={6}
            border={'solid 1px #A1D5F7'}
            borderRadius={4}
            alignItems={'center'}
          >
            <Text mr={6}>
              メンテナンス終了後は右のボタンを押して画面を更新してください。
            </Text>

            <Button
              colorStyle={'primary-outlined'}
              display={'inline-flex'}
              flexShrink={0}
              flexDirection={'column'}
              width={'72px'}
              height={'72px'}
              borderRadius={'8px'}
              onClick={() => window.location.reload()}
            >
              <View>
                <Refresh size={'32px'} />
              </View>
              <InlineText
                fontSize={'12px'}
                mt={-1}
                style={{ whiteSpace: 'nowrap' }}
              >
                更新する
              </InlineText>
            </Button>
          </Flexbox>
        </View>
      </Flexbox>
      <Footer py="16" />
    </Flexbox>
  )
}
